let conf = {
  logLevel: -1,
  chatbotUri: null,
  customerId: null,
  chatbotId: null,
  supportDiv: null,
  visitorId: null,
  lang: null,
  values: {},
  dependencies: {},
  appearances: [],
  autoDelayRatio: 1,
  services: {
    config: null,
    hub: null,
    livechat: null,
    analytics: null,
    billing: null
  },
  style: {
    colors: {
      main: '#039099',
      accent: '#fd4d00'
    },
    pin: {
      url: '',
      size: 'initial',
      position: 'right',
      offsetX: 50,
      offsetY: 0
    }
  },
  i18n: {
    languages: ['fr'],
    default: 'fr'
  },
  home: {
    header: {
      logo: {
        url: '',
        size: 'initial'
      },
      title: '',
      callToAction: {
        type: '',
        text: ''
      },
      slogan: '',
      marginBottom: 0
    },
    blocks: []
  },
  userContactDetails: {
    firstname: '',
    lastname: '',
    email: '',
    phone: ''
  },
  ignoreRGPD: false,
  ignoreExistingState: false,
  forceOpen: false,
  presetState: null,
  onReply: _ => true,
  onAdvisedProducts: _ => true,
  onAddToCart: _ => true
}

export default class Conf {
  static loadInitialData() {
    this.apply(window.noci.options || {})
    if (window.location.search.includes('noci_debug')) {
      this.apply({
        logLevel: 'debug'
      })
    }
  }

  static apply(obj) {
    conf = {
      ...conf,
      ...obj
    }
  }

  static get() {
    return conf
  }
}
